import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'panelComponents/Panel';
import AccountPackagePanel from 'accountComponents/AccountPackagePanel';
import { Tabs, Tab } from 'material-ui/Tabs';
import BillingPanel from 'accountComponents/BillingPanel';
import FeaturePanel from 'accountComponents/FeaturePanel';
import CommercialSummary from 'workOrderComponents/CommercialSummary';
import EquipmentOptionsPanel from 'equipmentComponents/EquipmentOptionsPanel';
import AccountAddButtons from 'accountComponents/AccountAddButtons';
import DongleEquipment from '../equipment/DongleEquipment';
import CpeEquipment from '../equipment/CpeEquipment';
import { yttvIntentServiceCodes } from '../../utils/accountEquipmentValidators';
import { green500, red500 } from 'material-ui/styles/colors';


class PackagePanel extends React.PureComponent {

    constructor(props, context) {
        super(props, context);

        this.handleChange = this
            .handleChange
            .bind(this);

        this.state = {
            value: 'account'
        };
    }

    handleChange(value) {
        this.setState({ value: value });
    }

    render() {

        const {
            orderDetails,
            packageDetail,
            orderServiceDetail,
            equipmentOptions,
            clearWorkOrderDetail,
            orderId,
            header,
            detailKey,
            customerDetails,
            billingDetails,
            schedulingSystemDetails,
            collectionDetails,
            commercialDetails,
            workOrderActions,
            techInventoryActions,
            accountAdd,
            equipmentDetails,
            dongleEquipmentAdd,
            techInventory,
            cpeEquipmentAdd,
            orderUserId,
            outletOptimizationDetails,
        } = this.props;

        let packages = null,
            packagesLoading = false,
            orderServices = null,
            orderServicesLoading = false,
            equipmentOptionsLoading = false,
            hasYTIntentCode = false,
            isCommercialAccOrBulk = false;

        if (equipmentOptions) {
            equipmentOptionsLoading = equipmentOptions.get('loading');
        }

        if (packageDetail) {
            packages = packageDetail.get('details');
            packagesLoading = packageDetail.get('loading');
            hasYTIntentCode = packages && packages.some(p => yttvIntentServiceCodes.includes(p.get('id').trim()));    
        }

        if(customerDetails)
        {
            isCommercialAccOrBulk = (customerDetails.get('customerType') == 'Commercial' || customerDetails.get('bulkFlag') == "True");
        }
        
        if (orderServiceDetail) {
            orderServices = orderServiceDetail.get('details');
            orderServicesLoading = orderServiceDetail.get('loading');
        }

        let billingSystem;
        let techId;

        if (schedulingSystemDetails) {
            billingSystem = schedulingSystemDetails.get('billingSystem');
            techId = schedulingSystemDetails.get('technicianId');
        }

        const accountNumber = customerDetails ? customerDetails.get('accountNumber') : '';
        const dongleEquipmentLoading = (dongleEquipmentAdd && dongleEquipmentAdd.get('loading')) || false;
        const textColor = dongleEquipmentAdd && dongleEquipmentAdd.get('isSuccess')
        ? green500
        : red500;

        const dongleUpdateMessage = dongleEquipmentAdd && dongleEquipmentAdd.get('message') ? (
            <p style={{
                color: textColor
            }}>{dongleEquipmentAdd.get('message')}</p>
        ) : null;


        const cpeEquipmentLoading = (cpeEquipmentAdd && cpeEquipmentAdd.get('loading')) || false;
        const cpeMessagetextColor = cpeEquipmentAdd && cpeEquipmentAdd.get('isSuccess')
        ? green500
        : red500;

        const cpeResultMessage = cpeEquipmentAdd && cpeEquipmentAdd.get('message') ? (
            <p style={{
                color: cpeMessagetextColor
            }}>{cpeEquipmentAdd.get('message')}</p>
        ) : null;

        const cpeSuccess = cpeEquipmentAdd && cpeEquipmentAdd.get('isSuccess');

        return (
            <Panel
                loading={packagesLoading || orderServicesLoading}
                hasDetails={true}
                orderId={orderId}
                detailKey={detailKey}
                clearWorkOrderDetail={clearWorkOrderDetail}
                header={header}>
                <Tabs
                    onChange={this.handleChange}
                    value={this.state.value}>
                    <Tab label="Acct" onActive={this.updateHeight} value="account">
                        <BillingPanel
                            customerInfo={customerDetails}
                            billingInfo={billingDetails}
                            collectionInfo={collectionDetails}
                            orderDetails={orderDetails} 
                            outletOptimizationDetails={outletOptimizationDetails}
                            />
                    </Tab>
                    <Tab label="Features" onActive={this.updateHeight} value="features">
                        <FeaturePanel
                            customerInfo={customerDetails}
                        />
                    </Tab>
                    <Tab label="Packages" onActive={this.updateHeight} value="accountPackages">
                        <AccountPackagePanel packages={packages} orderServices={orderServices} />

                    </Tab>
                    <Tab label="Add" onActive={this.updateHeight} value="equipmentOptions">
                        <div>
                            <EquipmentOptionsPanel
                                billingSystem={billingSystem}
                                equipmentOptions={equipmentOptions}
                                orderId={orderId}
                                accountNumber={accountNumber}
                                workOrderActions={workOrderActions}
                                equipmentOptionsLoading={equipmentOptionsLoading}
                                techId={techId}
                                equipmentDetails={equipmentDetails}
                            />
                            <AccountAddButtons
                                accountAdd={accountAdd}
                                orderDetails={orderDetails}
                                customerDetails={customerDetails}
                                billingDetails={billingDetails}
                                schedulingSystemDetails={schedulingSystemDetails}
                                packages={packages}
                                workOrderActions={workOrderActions}
                            />
                            {
                                hasYTIntentCode && <DongleEquipment
                                    workOrderActions={workOrderActions}
                                    accountNumber={accountNumber}
                                    title="YTV Mini"
                                    orderId={orderId}
                                    loading={dongleEquipmentLoading}
                                    updateMessage={dongleUpdateMessage}
                                    itemNumber="YTDVCFR"
                                />
                            }

                            {isCommercialAccOrBulk &&
                                <CpeEquipment
                                    title = "Add Extra Equipment"
                                    workOrderActions = {workOrderActions}
                                    techInventoryActions = {techInventoryActions}
                                    techInventory = {techInventory}
                                    orderUserId={orderUserId}
                                    accountNumber = {accountNumber}
                                    updateMessage = {cpeResultMessage}
                                    loading = {cpeEquipmentLoading}
                                    orderId = {orderId}
                                    successfulAdd = {cpeSuccess}
                                />
                            }
                        </div>
                    </Tab>
                    <Tab label="Comm." onActive={this.updateHeight} value="commercial">
                        <CommercialSummary commercialDetails={commercialDetails} />
                    </Tab>

                </Tabs>
            </Panel>
        );
    }
}

PackagePanel.propTypes = {
    orderDetails: PropTypes.object,
    packageDetail: PropTypes.object,
    orderServiceDetail: PropTypes.object,
    equipmentOptions: PropTypes.object,
    clearWorkOrderDetail: PropTypes.func,
    orderId: PropTypes.string,
    header: PropTypes.string,
    detailKey: PropTypes.string,
    customerDetails: PropTypes.object,
    billingDetails: PropTypes.object,
    schedulingSystemDetails: PropTypes.object,
    collectionDetails: PropTypes.object,
    commercialDetails: PropTypes.object,
    workOrderActions: PropTypes.object,
    accountAdd: PropTypes.object,
    equipmentDetails: PropTypes.object,
    dongleEquipmentAdd: PropTypes.object,
    techInventory: PropTypes.object,
    cpeEquipmentAdd: PropTypes.object
};

export default PackagePanel;



// WEBPACK FOOTER //
// ./src/components/account/PackagePanel.js